<script>
    export default {
        name: 'MobilePushApp',
        data: function() {
            return {
                header: '',
                text: null,
                image: null,
                file: null,
                action: null,
                imageSource: 'file',
                previewUpdateTimeout: null,
                confirmed: false,
                emoji: [],
            }
        },
        mounted: function() {
            this.text = this.$refs.text.dataset.value;
            this.header = this.$refs.header.dataset.value;
            this.image = this.$refs.image.dataset.value;
            if (this.image) {
                this.imageSource = 'link';
            }
        },
        methods: {
            initEmoji: function() {
                this.emoji = [];
            },
            updateHeader: function(header){
                this.header = header;
            },
            updateImage: function() {
                let app = this;

                if(this.previewUpdateTimeout) {
                    clearTimeout(this.timeout);
                }

                this.previewUpdateTimeout = setTimeout(function() {
                    app.image = app.file.generateDataUrl();
                }, 1000);
            },
            setImageSource: function(source) {
                this.imageSource = source; 
                this.image = '';
            },
            setAction: function(e) {
                this.action = e.target.name;
            },
            confirmSend: function(e) {
                if (this.action == 'send') {
                    let app = this;

                    if (!this.confirmed){
                        e.preventDefault();
                        this.$dialog.confirm(
                            'Вы действительно хотите отправить Mobile PUSH рассылку прямо сейчас?',
                            {
                                okText: 'Отправить',
                                cancelText: 'Отмена',
                                backdropClose: true,
                            }
                        ).then(
                            function(dialog) {
                                app.confirmed=true;
                                app.$refs.confirmSend.click();
                            }
                        ).catch(
                            function() {
                                app.confirmed=false;
                            }
                        ); 
                    }
                }
            }
        }
    }
</script>
